/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name
import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const JobStageListItemStatus = createEnum('JOB_STAGES_STATUS', {
  Active: 'ACTIVE',
  Inactive: 'DELETED',
});

export type JobStageListItemStatus = EnumSet<typeof JobStageListItemStatus>;

export type JobStageListItemDto = WithOptimisticLock<{
  id: ID;
  name: string;
  sortOrder: number;
  status: JobStageListItemStatus;
}>;

export type JobStagesFilterDto = {
  showDeleted?: boolean;
  searchString?: string;
};

export type newJobStageListItem = {
  name: string;
};
